import { isRoleSandbox } from "@/lib/runtimeMode";
import { Link } from "react-router";
import { CanAccess, useGetIdentity, useLogout } from "ra-core";
import { effectiveRole, getSalesRoleLabel } from "../sales/roles";
import { Button } from "@/components/ui/button";
import { ThemeModeToggle } from "@/components/admin/theme-mode-toggle";
import { useIsMobile } from "@/hooks/use-mobile";
import MobileHeader from "./MobileHeader";
import { MobileContent } from "./MobileContent";
export function WorkspacePage() {
  const { identity } = useGetIdentity();
  const logout = useLogout();
  const mobile = useIsMobile();
  const content = (
    <div className="mx-auto max-w-3xl space-y-6">
      <section
        data-mobile-reveal
        className="flex flex-wrap items-center justify-between gap-4 rounded-3xl border bg-card p-6"
      >
        <div>
          <h1 className="text-xl font-semibold">{identity?.fullName}</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {getSalesRoleLabel(effectiveRole(identity))}
          </p>
        </div>
        <ThemeModeToggle />
      </section>
      <div className="grid gap-3 sm:grid-cols-2">
        {[
          {
            to: "/profile",
            label: "Мой профиль",
            text: "Личные данные, уведомления и оформление",
          },
          {
            to: "/help",
            label: "Как пользоваться",
            text: "Инструкции по работе в CRM",
          },
          { to: "/changelog", label: "Что нового", text: "История обновлений" },
        ].map((i) => (
          <Link
            data-mobile-reveal
            key={i.to}
            to={i.to}
            className="rounded-2xl border bg-card p-5 transition-colors hover:bg-muted"
          >
            <h2 className="font-semibold">{i.label}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{i.text}</p>
          </Link>
        ))}
        {!isRoleSandbox() && (
          <CanAccess resource="admin_tools" action="list">
            <Link
              data-mobile-reveal
              to="/admin-tools"
              className="rounded-2xl border bg-card p-5 hover:bg-muted"
            >
              <h2 className="font-semibold">Админ-меню</h2>
              <p className="mt-1 text-sm text-muted-foreground">
                Песочница и проверка рабочих пространств всех ролей
              </p>
            </Link>
          </CanAccess>
        )}
        <CanAccess resource="sales" action="list">
          <Link
            data-mobile-reveal
            to="/sales"
            className="rounded-2xl border bg-card p-5 hover:bg-muted"
          >
            <h2 className="font-semibold">Пользователи и роли</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              Команда и права доступа
            </p>
          </Link>
        </CanAccess>
        <CanAccess resource="configuration" action="edit">
          <Link
            data-mobile-reveal
            to="/settings"
            className="rounded-2xl border bg-card p-5 hover:bg-muted"
          >
            Настройки системы
          </Link>
        </CanAccess>
        <CanAccess resource="import" action="create">
          <Link
            data-mobile-reveal
            to="/import"
            className="rounded-2xl border bg-card p-5 hover:bg-muted"
          >
            Импорт данных
          </Link>
        </CanAccess>
      </div>
      <Button variant="outline" onClick={() => logout()}>
        Выйти из аккаунта
      </Button>
    </div>
  );
  return mobile ? (
    <>
      <MobileHeader title="Кабинет" />
      <MobileContent>{content}</MobileContent>
    </>
  ) : (
    content
  );
}
